import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'

export interface DraftHuntDto {
  id: string
  huntName: string
  groupId: string
  groupName: string
  startTime: string
  endTime: string | null
  participantCount: number
  huntableGames: string[]
  lastStepIndex: number
  lastStepCompleted: string | null
}

export interface DraftHuntsResponse {
  hunts: DraftHuntDto[]
}

export function useDraftHunts() {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'me', 'hunts', 'drafts', uid],
    queryFn: () => call<DraftHuntsResponse>('/clubhouse/me/hunts/drafts'),
    enabled: !!uid,
    staleTime: 60 * 1000,
  })
}
